/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseType } from '../../models/course-type';
import { CourseTypeApiRespModel } from '../../models/course-type-api-resp-model';

export interface ApiMasterCourseTypeEditPost$Params {
      body?: CourseType
}

export function apiMasterCourseTypeEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterCourseTypeEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseTypeApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseTypeEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseTypeApiRespModel>;
    })
  );
}

apiMasterCourseTypeEditPost.PATH = '/api/Master/CourseType/Edit';
